import dataJson from "../../../../jsons/cnj_analysis.json";

const items = ["Estadual", "Federal", "Municipal"];
const dataOptions = [];
const seriesEstadual = [];
const seriesFederal = [];
const seriesMunicipal = [];

function sumValues(values) {
  let totEsfera = 0;

  values.map((value) => {
    if (!value) {
      return;
    }

    const dig = value;
    let val = dig + "";

    val = val.replace(".", "");
    val = parseInt(val);
    totEsfera = totEsfera + val;
  });

  return totEsfera;
}

function getValues(court) {
  items.map((item) => {
    if (item === "Estadual") {
      seriesEstadual.push(dataJson[court][item]?.valores || null);
    } else if (item === "Federal") {
      seriesFederal.push(dataJson[court][item]?.valores || null);
    } else {
      seriesMunicipal.push(dataJson[court][item]?.valores || null);
    }
  });
}

Object.keys(dataJson).map((court, i) => {
  if (court === "STJ") {
    dataOptions.push(court);
    getValues(court);
  } else if (court === "TJMMG" || court === "") {
  } else {
    dataOptions.push(court);
    getValues(court);
  }
});

let totMunicipal,
  totEstadual,
  totFederal = 0;
totMunicipal = sumValues(seriesMunicipal);
totEstadual = sumValues(seriesEstadual);
totFederal = sumValues(seriesFederal);

export const EsferaConfig = {
  series: [
    {
      name: "",
      data: [totMunicipal, totEstadual, totFederal],
    },
  ],
  options: {
    chart: {
      zoom: { enabled: false },
      fontFamily: "Hind Vadodara, Helvetica, Arial, sans serif",
      toolbar: { show: false },
      type: "bar",
      height: 350,
    },
    colors: ["#AADAFE", "#0281F1", "#012C6E"],
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: ["Municipal", "Estadual", "Federal"],
      labels: {
        formatter: function (value) {
          return value / 100000000000 + " bi";
        },
      },
    },
    yaxis: {
      show: true,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(val / 100);
        },
      },
    },
  },
};

export const TotalValueConfig = {
  series: [
    {
      name: "Municipal",
      data: seriesMunicipal,
    },
    {
      name: "Estadual",
      data: seriesEstadual,
    },
    {
      name: "Federal",
      data: seriesFederal,
    },
  ],
  options: {
    chart: {
      zoom: { enabled: false },
      fontFamily: "Hind Vadodara, Helvetica, Arial, sans serif",
      toolbar: { show: false },
      type: "bar",
      height: 350,
      background: "#fafafa",
      border: "1px solid #C2C2C2",
      marginTop: "3px",
    },
    colors: ["#AADAFE", "#0281F1", "#012C6E"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: dataOptions,
      labels: {
        show: true,
        minHeight: undefined,
        maxHeight: 120,
        offsetX: 0,
        offsetY: 0,
      },
    },
    yaxis: {
      logarithmic: true,
      labels: {
        show: true,
        formatter: function (value) {
          return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(value);
        },
      },
    },
    fill: {
      opacity: 1,
    },
    grid: {
      borderColor: "#cecece",
      padding: {
        top: 3,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(val);
        },
      },
    },
  },
};
